import React, { useEffect, useState, useReducer } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import { mask } from 'remask';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { instanceAxios } from '../../InstanceAxios';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import HeadTable from '../../components/HeadTable';
import TableSortLabel from "@material-ui/core/TableSortLabel";
import FilterIcon from "@material-ui/icons/FilterList";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  loading: {
    marginLeft: '50%',
  },
}));

function Usuario() {
  const TelefonePattern = ['(99)99999-9999'];
  const unmaskTelefone = ['99999999999'];
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [originalUsuarios, setOriginalUsuarios] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [senha, setSenha] = useState('');
  const [alert, setAlert] = useState(0);
  const [busca, setBusca] = useState('');
  const [ready, setReady] = useState(false);
  const [perfis, setPerfis] = useState([]);
  const [columns, setColumns] = useState([
    { id: 'nome', label: 'Nome', minWidth: 140,filterable: true },
    { id: 'email', label: 'Email', minWidth: 140,filterable: true },
    { id: 'telefone', label: 'Telefone', minWidth: 140,filterable: true },
    { id: 'ativo', label: 'Ativo', minWidth: 140,filterable: true },
    { id: 'editar', label: '', minWidth: 140,filterable: false },
  ]);
  const [usuario, setUsuario] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [checked, setChecked] = useState([]);
  const [novo, setNovo] = useState(true);
  const [campoOrdenacao, setCampoOrdenacao] = useState('');
  const [ordem, setOrdem] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const fetchPerfis = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/perfil`)
        .then((res) => {
          setPerfis(res.data);
        })
        .catch((err) => {
          setAlert(3);
          console.log(err);
        });
    };

    fetchUsuarios('', '');
    fetchPerfis();
  }, []);

  const fetchUsuarios = async (cmpOrd, ord) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/internos?campoOrdenacao=${cmpOrd}&ordem=${ord}`)
      .then((res) => {
        setUsuarios(res.data);
        setOriginalUsuarios(res.data);
        setReady(true);
      })
      .catch((err) => {
        setReady(true);
        setAlert(3);
        console.log(err);
      });
  };

  const clickAlert = () => {
    setAlert(0);
  };

  const editUser = (usuario) => {
    clickAlert();
    setUsuario(usuario);
    setNome(usuario.nome);
    setEmail(usuario.email);
    setTelefone(usuario.telefone);
    // atualizando checked
    const checkedLocal = [];
    if (usuario.PerfilUsuarios) {
      usuario.PerfilUsuarios.forEach((pu) => checkedLocal.push(pu.id_perfil));
    }
    setChecked(checkedLocal);
    setNovo(false);
    setOpenModal(true);
  };

  const addUser = () => {
    setNovo(true);
    setOpenModal(true);
  };

  const handleClose = () => {
    clickAlert();
    cleanFields();
    setOpenModal(false);
    // atualizando checked
    setChecked([]);
  };

  const cleanFields = () => {
    setUsuario({});
    setNome('');
    setEmail('');
    setSenha('');
    setTelefone('');
    setChecked([]);
  };

  const handleAtivarDesativar = async () => {
    setAlert(1);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/cliente/ativar/${usuario.id}`)
      .then((resp) => {
        setAlert(2);
      })
      .catch((err) => {
        setAlert(3);
      });
  };

  const handleCampoOrdenacao = (co) => {
    // Checando se Não é a coluna Editar
    if (co === 'editar') return;

    let o;
    // Checando se é o mesmo atual
    if (co === campoOrdenacao) {
      o = ordem === 'asc' ? 'desc' : 'asc';
      setOrdem(o);
    } else {
      o = 'asc';
      setOrdem(o);
      setCampoOrdenacao(co);
    }
    fetchUsuarios(co, o);
  };

  const handleVincular = async (idPerfil) => {
    const lista = checked;
    // Checando se é Edição para vincular pagamento ou apenas guardar para salvar
    if (!novo) {
      if (lista.includes(idPerfil)) {
        if (lista.length === 1) {
          setAlert(4);
          return;
        }
        await instanceAxios(localStorage.getItem('toobiauth'))
          .delete(`/perfilUsuario/${usuario.id}/${idPerfil}`)
          .then((data) => {
            lista.splice(lista.indexOf(idPerfil), 1);
            setAlert(2);
          })
          .catch((err) => {
            setAlert(3);
          });
      } else {
        await instanceAxios(localStorage.getItem('toobiauth'))
          .post(`/perfilUsuario`, {
            id_usuario: usuario.id,
            id_perfil: idPerfil,
          })
          .then((data) => {
            lista.push(idPerfil);
            setAlert(2);
          })
          .catch((err) => {
            setAlert(3);
          });
      }
    } else if (lista.includes(idPerfil))
      lista.splice(lista.indexOf(idPerfil), 1);
    else lista.push(idPerfil);
    setChecked(lista);
    forceUpdate();
  };

  const chipAtivo = (ativo) => {
    if (ativo) {
      return (
        <Chip
          label="Ativo"
          style={{ backgroundColor: XMEI_PRIMARY_COLOR, color: '#FFF' }}
        />
      );
    }
    return <Chip label="Desativo" color="secondary" />;
  };


  const openModalFilter = (event, columnid) => {
    setFilterText('')
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top , left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalUsuarios.filter(item => {
      const value = getValueColumnId(columnId,item);
      return value && value.toString().toLowerCase().includes(filterText.toLowerCase());
    });
    // Update the table data with filtered data
    setUsuarios(filteredDas);
  };

  const getValueColumnId = (columnIdAux,rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  }

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setUsuarios(originalUsuarios);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;


    if (idOrder === property && order === 'desc') {
      setOrder('asc')
    }else{
      setOrder('desc')
    }


    setIdOrder(orderBy);

  };

  const sortTable = (property) => {


    const isAsc = order === 'asc';
    usuarios.sort((a, b) => {
      let aValue = getValueColumnId(property,a);
      let bValue = getValueColumnId(property,b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setUsuarios(usuarios);
  };

  const renderPerfil = () => {
    return (
      <>
        <h2 style={{ fontSize: '1.2em' }}>Perfis</h2>
        <FormControl component="fieldset">
          <FormGroup>
            {perfis.map((p, i) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes(p.id)}
                    onChange={() => handleVincular(p.id)}
                  />
                }
                label={p.nome}
              />
            ))}
          </FormGroup>
          <FormHelperText>Vincule o acesso com o Perfil</FormHelperText>
        </FormControl>
      </>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 20,
      }}
    >
      <Modal open={isModalOpen} onClose={closeModal} style={{ top: modalPosition.top, left: modalPosition.left }}>
        <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '5px', width: '300px' }}>
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button variant="contained" color="primary" onClick={filterTable} style={{ marginTop: '10px' }}>
            Filtrar
          </Button>
          <Button  variant="contained" color="secondary" onClick={clearFilter} style={{ marginTop: '10px',marginLeft: '5px',width:70 }}>
            Limpar
          </Button>
        </div>
      </Modal>

      <Collapse in={alert === 3}>
        <Alert severity="error" onClick={clickAlert}>
          Erro criar/editar usuario,tente mais tarde!
        </Alert>
      </Collapse>
      <Collapse in={alert === 2}>
        <Alert severity="success" onClick={clickAlert}>
          Usuario criado/editado com sucesso!
        </Alert>
      </Collapse>
      <h1>Usuários</h1>
      <Paper style={{ width: '95%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: 10,
          }}
        >
          <Button
            variant="contained"
            startIcon={<PersonAddIcon />}
            onClick={() => addUser()}
            style={{
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
          >
            Novo
          </Button>
          <TextField
            id="busca"
            label="Busca"
            value={busca}
            onChange={async (event) => {
              setBusca(event.target.value);
              await instanceAxios(localStorage.getItem('toobiauth'))
                .get(`/internos?nome=${event.target.value}`)
                .then((res) => {
                  setUsuarios(res.data);
                })
                .catch((err) => {
                  console.log(err);
                  setAlert(2);
                });
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Collapse in={ready}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{minWidth: column.minWidth}}
                  >
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {column.filterable && (
                        <IconButton style={{marginLeft:-5}}   onClick={event => openModalFilter(event,column.id)} aria-label="filtra">
                          <FilterIcon style={{width:16,height:16  }} />
                        </IconButton>
                      )}
                    </div>

                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {usuarios.map((u) => {
                const estilo = u.ativo ? {} : { color: '#ffb42e' };
                return (
                  <TableRow key={u.id}>
                    <TableCell component="th" scope="row" style={estilo}>
                      {u.nome}
                    </TableCell>
                    <TableCell component="th" scope="row" style={estilo}>
                      {u.email}
                    </TableCell>
                    <TableCell component="th" scope="row" style={estilo}>
                      {u.telefone ? mask(u.telefone, TelefonePattern) : ''}
                    </TableCell>
                    <TableCell component="th" scope="row" style={estilo}>
                      {chipAtivo(u.ativo)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => editUser(u)}
                        style={{
                          color: XMEI_PRIMARY_COLOR,
                        }}
                        aria-label="Editar Clientes"
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Collapse>
        <Collapse in={!ready}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>

      <Modal open={openModal} onClose={handleClose}>
        <Grid
          container
          spacing={3}
          className={classes.paper}
          style={{
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
            width: '80%',
            height: '80%',
            overflow: 'auto',
          }}
        >
          <Collapse in={alert === 1}>
            <Alert severity="warning" onClick={clickAlert}>
              Preencha todos dados necessários
            </Alert>
          </Collapse>
          <Collapse in={alert === 3}>
            <Alert severity="error" onClick={clickAlert}>
              Erro ao vincular perfil
            </Alert>
          </Collapse>
          <Collapse in={alert === 2}>
            <Alert severity="success" onClick={clickAlert}>
              Perfil Vinculado/Desvinculado com sucesso
            </Alert>
          </Collapse>
          <Collapse in={alert === 4}>
            <Alert severity="error" onClick={clickAlert}>
              Usuário não pode ficar sem Perfil!
            </Alert>
          </Collapse>
          <Grid item xs={12}>
            <Grid container spacing={3} style={{ marginBottom: '5%' }}>
              <Typography variant="h4">Usuário</Typography>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="nome"
                  label="Nome"
                  variant="outlined"
                  value={nome}
                  onChange={(event) => setNome(event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="email"
                  label="Email"
                  variant="outlined"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="telefone"
                  label="Telefone"
                  variant="outlined"
                  value={mask(telefone, TelefonePattern)}
                  onChange={(event) => setTelefone(event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="senha"
                  label="Senha"
                  variant="outlined"
                  type={showPassword ? 'text' : 'password'}
                  value={senha}
                  onChange={(event) => setSenha(event.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <IconButton>
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                {renderPerfil()}
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ paddingTop: '5%' }}>
              <Grid item xs={6}>
                <Collapse in={!novo}>
                  <Collapse in={usuario.ativo}>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<DeleteIcon />}
                      onClick={handleAtivarDesativar}
                    >
                      Desativar
                    </Button>
                  </Collapse>
                  <Collapse in={!usuario.ativo}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<CheckIcon />}
                      onClick={handleAtivarDesativar}
                    >
                      Ativar
                    </Button>
                  </Collapse>
                </Collapse>
              </Grid>
              <Grid item xs={6}>
                <div align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={async () => {
                      if (nome === '' || email === '') {
                        setAlert(1);
                        return;
                      }
                      const obj = novo ? {} : usuario;
                      obj.nome = nome;
                      obj.email = email;
                      obj.telefone = telefone;
                      if (senha !== '') {
                        obj.senha = senha;
                      }

                      if (novo && checked.length === 0) {
                        setAlert(4);
                        return;
                      }

                      console.log(obj);
                      await instanceAxios(localStorage.getItem('toobiauth'))
                        .post(`/internos`, obj)
                        .then(async (res) => {
                          cleanFields();
                          if (novo) {
                            for (const c of checked) {
                              await instanceAxios(
                                localStorage.getItem('toobiauth')
                              )
                                .post(`/perfilUsuario`, {
                                  id_usuario: res.data.id,
                                  id_perfil: c,
                                })
                                .then((data) =>
                                  console.log('Adicionando Perfil!')
                                )
                                .catch((err) => setAlert(3));
                            }
                            setUsuarios([...usuarios, res.data]);
                          } else {
                            const arrayUsuarios = usuarios;
                            const index = arrayUsuarios
                              .map((e) => {
                                return e.id;
                              })
                              .indexOf(res.data.id);
                            arrayUsuarios.splice(index, 1);
                            arrayUsuarios.push(res.data);
                            setUsuarios(arrayUsuarios);
                          }
                          setOpenModal(false);
                          setAlert(2);
                        })
                        .catch((err) => {
                          console.log(err);
                          cleanFields();
                          setOpenModal(false);
                          setAlert(3);
                        });
                    }}
                  >
                    Salvar
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
}

export default Usuario;
